import { useEffect, useState } from 'react';

import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
    Typography,
} from '@mui/material';
import styled from 'styled-components';

import { useVendorsHook } from '../../../Hooks/Maintenance/Vendors/vendorsHooks';

import { IconEdit, IconPlus, IconTrash } from '@tabler/icons-react';

import { TableContainer } from '../../../Styles/CustomViews/Pages/ListComponent/customListComponentStyles';

import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';
import DateHelper from '../../../Utilities/Helpers/DateHelper';
import RouteHelper from '../../../Utilities/Helpers/RouteHelper';
import AccessibilityHelper from '../../../Utilities/Helpers/AccessibilityHelper';

import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';
import { RouteEnum } from '../../../Utilities/Enums/RouteEnums';
import { ButtonType } from '../../../Utilities/Enums/ButtonTypeEnum';
import { VendorField } from '../../../Utilities/Enums/ParametersEnum';
import { AdminModules } from '../../../Utilities/Enums/AdminModulesEnum';
import { OrderByEnum } from '../../../Utilities/Enums/SortEnums';

import { Vendor } from '../../../Models/Maintenance/Vendors/Vendor';

import CustomListComponent from '../../../CustomViews/Pages/ListComponent/CustomListComponent';
import CustomIconButton from '../../../CustomViews/Elements/CustomIconButton';
import CustomDeleteConfirmation from '../../../CustomViews/Elements/CustomDeleteConfirmation/CustomDeleteConfirmation';
import CustomButton from '../../../CustomViews/Elements/CustomButton';
import CustomListHeader from '../../../CustomViews/Pages/ListComponent/CustomListHeader';
import CustomListSearch from '../../../CustomViews/Pages/ListComponent/Search/CustomListSearch';
import { CustomListSearchResetBtns } from '../../../CustomViews/Pages/ListComponent/Search/CustomListSearchResetBtns';
import FormDatePicker from '../../../CustomViews/Elements/FormDatePicker';
import FormTextField from '../../../CustomViews/Elements/FormTextField';
import AddEditVendorModal from './AddEditVendorModal';

const VendorCompaniesContainer = styled.div<{}>`
    // .contactDetailItem {
    //     width: 100%;
    //     font-size: 0.75rem;
    //     font-weight: 600;
    //     display: grid;
    //     grid-template-columns: 0.1fr 1.5fr;
    //     align-items: start;

    //     svg {
    //         width: 12px;
    //         height: 12px;
    //         margin: 3px 5px 0px 0px;
    //     }
    // }

    // .contactName {
    //     // grid-column: span 2;
    //     display: unset;
    //     grid-template-columns: unset;
    // }

    .companyName {
        font-size: 13px;
        font-weight: 400;
        // color: grey;
        line-height: 1;
        margin: 0px 0px 5px 0px;
    }
`;

export default function VendorsList() {
    const navigate = useNavigate();
    const location = useLocation()

    //search params
    const queryParams = new URLSearchParams(location.search);
    const [searchParams, setSearchParams] = useSearchParams(queryParams);

    //use states
    const [openDelete, setopenDelete] = useState(false);
    const [openAddEditModal, setopenAddEditModal] = useState(false);
    let [selectedVendor, setselectedVendor] = useState<Vendor>(new Vendor());
    const [queryStr, setQueryStr] = useState({
        pageSize: QueryBuilderHelper.DefaultPageSizeValue(),
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
        lastUpdatedDate: QueryBuilderHelper.DefaultQueryFilterValue('lastUpdatedDate', null),
        sortBy: QueryBuilderHelper.DefaultSortValue(VendorField.NAME),
        orderBy: QueryBuilderHelper.DefaultOrderValue(OrderByEnum.DESC),
    });

    const q_queryKey = [CachingEnum.VENDOR, queryStr]
    const { data, fetchStatus, deleteVendorById } = useVendorsHook(q_queryKey, queryStr);

    const tableColumns = [
        {
            accessor: VendorField.CODE,
            title: "Code",
            sortable: true,
            render: (record: Vendor) => (AccessibilityHelper.hasAccess(AdminModules.VENDORS_EDIT) ?
                <Typography sx={{ cursor: "pointer" }} variant="caption" color="info" gutterBottom onClick={() => {
                    setopenAddEditModal(true);
                    setselectedVendor(record);
                }} >{record?.[VendorField.CODE] ?? "--"}</Typography> : (record?.[VendorField.CODE] ?? "--")
            )
        },
        {
            accessor: VendorField.NAME,
            sortable: true,
        },
        {
            accessor: VendorField.COMPANIES,
            sortable: true,
            render: (record: Vendor) => <VendorCompaniesContainer>
                {record?.[VendorField.COMPANIES]?.map((company: any) => {
                    return <>{company?.name != null && company?.name != "" && <Typography className="companyName">{company?.name ?? ""}</Typography>}</>
                })}
            </VendorCompaniesContainer>
        },
        {
            accessor: VendorField.UPDATED_DATE,
            title: 'Last Updated',
            sortable: true,
            render: (record: Vendor) => record?.[VendorField.UPDATED_DATE] ? DateHelper.getFormattedDate(record?.[VendorField.UPDATED_DATE], "dd/MM/yyyy hh:mm a") : "--",
        },
        {
            accessor: 'action',
            title: "Action",
            render: (record: Vendor) => <>
                {AccessibilityHelper.hasAccess(AdminModules.VENDORS_EDIT) && <CustomIconButton toolTipName='Edit'
                    icon={<IconEdit />}
                    onClick={(e: any) => {
                        setopenAddEditModal(true);
                        setselectedVendor(record);
                    }} />}
                {AccessibilityHelper.hasAccess(AdminModules.VENDORS_DELETE) && <CustomIconButton toolTipName='Delete'
                    icon={<IconTrash color='var(--buttonHoverBGDangerColor)' />}
                    onClick={(e: any) => { 
                        setopenDelete(true);
                        setselectedVendor(record);
                    }} />}
            </>
        },
    ];

    useEffect(() => {
        setSearchParams(QueryBuilderHelper.CleanQueryDictionary(queryStr));
    }, [queryStr]);

    return <TableContainer>
        <CustomListHeader title={RouteHelper.getRouteDescription(RouteEnum.VENDORS)}
            subTitle=""
            headerButtons={<>
                {AccessibilityHelper.hasAccess(AdminModules.VENDORS_CREATE) && <CustomButton
                    btnType={ButtonType.PRIMARY}
                    title='Add New'
                    startIcon={<IconPlus />}
                    // isRoundedCorner={true}
                    onClick={(e: any) => {
                        setopenAddEditModal(true);
                        setselectedVendor(new Vendor());
                    }} />}
            </>}
        />
        <CustomListSearch searchValue={queryStr.searchString ?? ""}
            onChangeSearch={(searchString) => setQueryStr(prev => ({ ...prev, searchString: searchString, pageNumber: 1 }))}
            searchPlaceholder='Search Vendor'
            onClickLegendItem={(id) => setQueryStr(prev => ({ ...prev, status: id, pageNumber: 1 }))}>
            <FormDatePicker name="vendorUpdatedDate"
                hideLabel
                title=''
                placeholder='Last Updated Date'
                fieldValue={queryStr.lastUpdatedDate}
                handleOnChange={(date: Date) => setQueryStr(prev => ({
                    ...prev,
                    lastUpdatedDate: date ?? DateHelper.getFormattedDate(new Date(), "yyyy-MM-dd"),
                    pageNumber: 1,
                }))} />
            <CustomListSearchResetBtns onClickSearch={() => { }}
                onClickReset={() => {
                    setQueryStr(prev => ({
                        ...prev,
                        searchString: '',
                        lastUpdatedDate: null,
                        pageNumber: 1,
                     }))
                }}/>
        </CustomListSearch>
        <CustomListComponent
            columns={tableColumns}
            fetching={fetchStatus == "fetching"}
            idAccessor={(record: Vendor) => `vendor${record?.[VendorField.PUBLIC_ID]}`}
            records={data?.data?.list ?? []}
            totalRecords={data?.data?.metaData?.totalCount ?? 0}
            page={queryStr.pageNumber}
            recordsPerPage={queryStr.pageSize}
            defaultColumnSort={{ columnAccessor: queryStr?.sortBy ?? 'id', direction: queryStr?.orderBy ?? 'asc' }}
            onSortStatusChange={((sort: any) => { setQueryStr((prev: any) => ({ ...prev, sortBy: sort?.columnAccessor ?? "id", orderBy: sort?.direction ?? "asc", pageNumber: 1 })) })}
            setPage={(p: number) => setQueryStr((prev: any) => ({ ...prev, pageNumber: p }))}
            onRecordsPerPageChange={(p: number) => setQueryStr((prev: any) => ({ ...prev, pageSize: p, pageNumber: 1 }))} />

        {openDelete && <CustomDeleteConfirmation
            openDialog={openDelete}
            ItemToDelete={selectedVendor?.[VendorField.NAME] ?? null} // Optional to display name of the item to be deleted
            handleClose={() => {
                setopenDelete(false);
                setselectedVendor(new Vendor());
            }}
            showRemarksField={true}
            deleteItem={async (remarks: any) => {
                if(selectedVendor?.[VendorField.PUBLIC_ID]) {
                    let deleteReponse: any = await deleteVendorById(selectedVendor?.[VendorField.PUBLIC_ID], remarks);

                    if(deleteReponse?.isSuccess) {
                        setopenDelete(false);
                        setselectedVendor(new Vendor());
                    }
                }
            }} />
        }

        {openAddEditModal && <AddEditVendorModal
            openAddEditModal={openAddEditModal}
            setopenAddEditModal={setopenAddEditModal}
            selectedVendor={selectedVendor}
            setselectedVendor={setselectedVendor} /> }
    </TableContainer>
}
